<template>
    <b-card no-body>
        <b-form style="margin: 1.25rem">
            <b-row>
                <b-col>
                    <b-form-group :label="$t('simulation.lowLimit')">
                        <b-form-input
                            id="lowLimit"
                            min="0"
                            max="999999"
                            step="1"
                            @change="
                                (value) => {
                                    if (this.simulationDetails.LowLimit >= this.simulationDetails.HighLimit) {
                                        this.simulationDetails.HighLimit = this.simulationDetails.LowLimit * 1 + this.simulationDetails.Increment * 1;
                                    }
                                    if (value == null || value == '') {
                                        this.simulationDetails.LowLimit = 0;
                                    } else if (value > 999999) {
                                        this.simulationDetails.LowLimit = 999999;
                                    } else if (value < -1000000) {
                                        this.simulationDetails.LowLimit = -1000000;
                                    }
                                }
                            "
                            v-model="simulationDetails.LowLimit"
                            type="number"
                        />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t('simulation.highLimit')">
                        <b-form-input
                            id="highLimit"
                            min="1"
                            max="1000000"
                            step="1"
                            @change="
                                (value) => {
                                    if (this.simulationDetails.HighLimit <= this.simulationDetails.LowLimit) {
                                        this.simulationDetails.LowLimit = this.simulationDetails.HighLimit * 1 - this.simulationDetails.Increment * 1;
                                    }
                                    if (value == null || value == '') {
                                        this.simulationDetails.HighLimit = 0;
                                    } else if (value > 1000000) {
                                        this.simulationDetails.HighLimit = 1000000;
                                    } else if (value < -999999) {
                                        this.simulationDetails.HighLimit = -999999;
                                    }
                                }
                            "
                            v-model="simulationDetails.HighLimit"
                            type="number"
                        />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t('simulation.increment')">
                        <b-form-input
                            id="increment"
                            min="1"
                            max="1000000"
                            step="1"
                            @change="
                                (value) => {
                                    if (this.simulationDetails.Increment > this.simulationDetails.HighLimit * 1 - this.simulationDetails.LowLimit * 1) {
                                        this.simulationDetails.Increment = this.simulationDetails.HighLimit * 1 - this.simulationDetails.LowLimit * 1;
                                    }
                                    if (value == null || value == '') {
                                        this.simulationDetails.Increment = 1;
                                    } else if (value > 1000000) {
                                        this.simulationDetails.Increment = 1000000;
                                    } else if (value < 1) {
                                        this.simulationDetails.Increment = 1;
                                    }
                                }
                            "
                            v-model="simulationDetails.Increment"
                            type="number"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </b-card>
</template>

<script>
export default {
    name: 'Ramp',
    props: {
        simulationDetails: Object,
        type: String,
    },
    mounted() {
        if (this.simulationDetails.LowLimit == null || this.simulationDetails.LowLimit == '') {
            this.$set(this.simulationDetails, 'LowLimit', 0);
        }
        if (this.simulationDetails.HighLimit == null || this.simulationDetails.HighLimit == '') {
            this.$set(this.simulationDetails, 'HighLimit', 10);
        }
        if (this.simulationDetails.Increment == null || this.simulationDetails.Increment == '') {
            this.$set(this.simulationDetails, 'Increment', 1);
        }
    },
};
</script>